export const SITE_ORIGIN = 'https://picinez.com';
export const DEFAULT_INSPECTOR_TAB_SLUG = 'watermarks';

export const INSPECTOR_TABS = [
    {
        slug: 'background',
        label: 'Background',
        seo: {
            title: 'Remove Background & Text Behind Image Online Free | Picinez',
            description: 'Remove backgrounds, apply effects to the background only, and place text or images behind your subject. Free batch background and text-behind-image tool in your browser at Picinez.com.',
            keywords: 'remove background, text behind image, text behind subject, background removal, batch background editor',
            heading: 'Background Removal & Text Behind Image',
            intro: 'Remove backgrounds, blur or recolor the backdrop, and place text or graphics behind your subject so they peek out naturally from the foreground.',
        },
    },
    {
        slug: 'watermarks',
        label: 'Watermarks',
        seo: {
            title: 'Free Online Watermark Maker — Add Text or Logo to Photos | Picinez',
            description: 'Create text and image watermarks for photos online. Batch watermark maker with font, size, color, transparency, angle, and nine placement positions. Free at Picinez.com.',
            keywords: 'watermark maker, add watermark, photo watermark, batch watermark, text watermark, logo watermark',
            heading: 'Free Online Watermark Maker',
            intro: 'Add text or image watermarks to multiple photos at once. Choose font, size, color, transparency, angle, and placement — all in your browser.',
        },
    },
    {
        slug: 'effects',
        label: 'Effects',
        seo: {
            title: 'Pixel Effects Online — Tiles, Dots, Squares, Cubes & ASCII | Picinez',
            description: 'Turn photos into tile mosaics, shaded cubes, screen-like squares, dot grids, or ASCII art with a custom color palette. Free batch pixel effects in your browser at Picinez.com.',
            keywords: 'pixel mosaic, image tiles, cube mosaic, square mosaic, LED effect, dot mosaic, ASCII art effect, batch pixel art',
            heading: 'Pixel Effects & Mosaic Styles',
            intro: 'Rebuild photos as colored tiles, shaded cubes, screen-like squares, shaded dots, or ASCII characters. Pick a palette, set tile size, and apply the look across a whole batch.',
        },
    },
    {
        slug: 'colors',
        label: 'Colors',
        seo: {
            title: 'Batch Image Color Editor — Adjust Colors Online Free | Picinez',
            description: 'Adjust brightness, contrast, saturation, hue, and color effects on multiple images online. Free batch color editing tool at Picinez.com.',
            keywords: 'image color editor, batch color adjust, brightness contrast, photo color correction',
            heading: 'Batch Image Color Editor',
            intro: 'Fine-tune color, brightness, contrast, and tonal effects across a whole batch of images without uploading files to a server.',
        },
    },
    {
        slug: 'blur-sharp',
        label: 'Blur/Sharp',
        seo: {
            title: 'Blur and Sharpen Images Online — Batch Blur/Sharp Tool | Picinez',
            description: 'Blur or sharpen multiple images online for free. Apply batch blur and sharpening effects in your browser with Picinez.',
            keywords: 'blur image online, sharpen image, batch blur, photo sharpening tool',
            heading: 'Blur and Sharpen Images Online',
            intro: 'Soften or sharpen photos in bulk. Useful for privacy blurs, creative effects, and quick clarity adjustments.',
        },
    },
    {
        slug: 'decor',
        label: 'Decor',
        seo: {
            title: 'Decorate Photos Online — Batch Image Decoration Effects | Picinez',
            description: 'Apply decorative effects to multiple images online. Free batch photo decoration tools at Picinez.com.',
            keywords: 'photo decoration, image effects, batch photo editor, decorate images online',
            heading: 'Decorate Photos Online',
            intro: 'Apply decorative effects to batches of images for social posts, catalogs, and creative projects.',
        },
    },
    {
        slug: 'transform',
        label: 'Transform',
        seo: {
            title: 'Bulk Image Resizer and Crop Tool — Resize Photos Online | Picinez',
            description: 'Resize, rotate, flip, zoom, and crop multiple images at once online. Free bulk image resizer with pixel, percent, and auto sizing at Picinez.com.',
            keywords: 'bulk image resizer, resize photos online, batch crop, rotate images, image transform',
            heading: 'Bulk Image Resizer and Transform Tool',
            intro: 'Resize, rotate, flip, zoom, and crop multiple images at once. Set width and height in pixels, percent, or auto.',
        },
    },
    {
        slug: 'misc',
        label: 'Misc',
        seo: {
            title: 'Miscellaneous Batch Image Tools — Extra Photo Effects | Picinez',
            description: 'Additional batch image processing tools and effects for photos. Free online misc image tools at Picinez.com.',
            keywords: 'batch image tools, photo effects, online image processor, misc image editor',
            heading: 'Miscellaneous Batch Image Tools',
            intro: 'Extra batch processing options and effects for specialized image workflows.',
        },
    },
    {
        slug: 'settings',
        label: 'Settings',
        seo: {
            title: 'Batch Image Export Settings — Output Format Options | Picinez',
            description: 'Configure output format and save options for batch image processing. Export JPEG, PNG, or WebP with Picinez.',
            keywords: 'image export settings, save as jpeg png webp, batch export options',
            heading: 'Batch Image Export Settings',
            intro: 'Choose output format and save options before downloading your processed images.',
        },
    },
];

export function getInspectorTabBySlug(slug) {
    return INSPECTOR_TABS.find(tab => tab.slug === slug)
        || INSPECTOR_TABS.find(tab => tab.slug === DEFAULT_INSPECTOR_TAB_SLUG);
}

export function getInspectorTabSeo(slug) {
    return getInspectorTabBySlug(slug).seo;
}

export function getInspectorTabSlugFromPath(pathname) {
    const segments = pathname.replace(/\/+$/, '').split('/').filter(Boolean);
    const slug = segments[segments.length - 1];

    if (INSPECTOR_TABS.some(tab => tab.slug === slug)) {
        return slug;
    }

    return DEFAULT_INSPECTOR_TAB_SLUG;
}

export function getInspectorTabIndexFromSlug(slug) {
    const index = INSPECTOR_TABS.findIndex(tab => tab.slug === slug);
    if (index >= 0) {
        return index;
    }

    return INSPECTOR_TABS.findIndex(tab => tab.slug === DEFAULT_INSPECTOR_TAB_SLUG);
}

export function getInspectorTabPath(slug) {
    return `/${slug}`;
}

export function getInspectorTabCanonicalUrl(slug, origin = SITE_ORIGIN) {
    return `${origin}${getInspectorTabPath(slug)}`;
}

export function syncInspectorTabUrl(slug, { replace = false } = {}) {
    const path = getInspectorTabPath(slug);

    if (window.location.pathname === path) {
        return;
    }

    if (replace) {
        window.history.replaceState(null, '', path);
    } else {
        window.history.pushState(null, '', path);
    }
}
